// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"22366f66","877":"22366f66"}[chunkId] + ".chunk.css";
};